<template>
	<div class="dashboard-container p-10">
		<div>
			<div v-if="!isLoggedIn">
				<h1>{{ $t('welcomeLogin') }}</h1>
				<el-button @click="onLogin">Log in</el-button>
			</div>
			<component :is="currentRole" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import adminDashboard from './admin';
import editorDashboard from './editor';
import cognito from '@/cognito';
import { determineLoggedInStatus } from '@/utils/auth';

export default {
	name: 'Dashboard',
	components: { adminDashboard, editorDashboard },
	data() {
		return {
			currentRole: 'adminDashboard'
		};
	},
	computed: {
		...mapGetters(['roles']),
		isLoggedIn() {
			return determineLoggedInStatus();
		}
	},
	created() {
		if (!this.roles.includes('admin') && !this.roles.includes('user')) {
			this.currentRole = 'editorDashboard';
		}
	},
	methods: {
		onLogin() {
			cognito.login();
		}
	}
};
</script>
